import React, { useMemo } from 'react';
import { Card, Descriptions, Typography } from '../../../components';
import { getGiBfromKiB, getMSSQLInstancesDisplayInfo } from '../../../lib/helpers';

const { Text } = Typography;

const SystemInformation = React.memo(({ cpu, memory, hardware, os, migrate_by_vm }) => {
    const sqlInstances = useMemo(() => {
        if (migrate_by_vm || !os?.installed_programs) {
            return [];
        }

        const sqlPrograms = os.installed_programs.filter((program) => program.product_family === 'mssql');

        return getMSSQLInstancesDisplayInfo(sqlPrograms);
    }, [os?.installed_programs, migrate_by_vm]);
    return (
        <Card title="System Information" size="small" type="inner">
            <Descriptions column={1} size="small">
                {cpu?.processors?.length ? (
                    migrate_by_vm ? (
                        <Descriptions.Item label="CPU">{cpu.processors.length}</Descriptions.Item>
                    ) : (
                        cpu.processors.map((proc, index) => (
                            <Descriptions.Item key={index} label={index === 0 ? 'CPU' : undefined}>
                                <div style={index !== 0 ? { marginLeft: 40 } : {}}>
                                    {index + 1} {proc?.model}
                                </div>
                            </Descriptions.Item>
                        ))
                    )
                ) : (
                    <Descriptions.Item label="CPU">N/A</Descriptions.Item>
                )}
                <Descriptions.Item label="Memory">
                    {memory?.total_kb ? `${getGiBfromKiB(memory.total_kb)} GiB RAM` : 'N/A'}
                </Descriptions.Item>
                <Descriptions.Item label="Platform">{hardware?.platform || 'N/A'}</Descriptions.Item>
                <Descriptions.Item label="Architecture">{os?.arch || 'N/A'}</Descriptions.Item>
                <Descriptions.Item label="OS">{os?.desc || 'N/A'}</Descriptions.Item>
                {!migrate_by_vm && sqlInstances.length > 0 && (
                    <Descriptions.Item label="Microsoft SQL Server">
                        <ul style={{ margin: 0, paddingLeft: 0, listStyle: 'none' }}>
                            {sqlInstances.map((instance, index) => (
                                <li key={instance.id || index}>{instance.display_name}</li>
                            ))}
                        </ul>
                    </Descriptions.Item>
                )}
            </Descriptions>
        </Card>
    );
});

export default SystemInformation;
